import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import { Button, MenuItem, Popover, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import KidsAgeForm from 'src/components/BuyPolicy/insuranceScreens/health/ageForms/KidsAgeForm'
import ParentsAndInLawsAgeForm from 'src/components/BuyPolicy/insuranceScreens/health/ageForms/ParentsAndInLawsAgeForm'
import { Badge } from '@material-ui/core'
import {
  getParentsMinAge,
  hasFilledKidAge,
  isValidAge,
} from 'src/utils/commonMethods/buyPolicy'
import { getFormattedRequestObjects } from 'src/services/buyPolicyService'
import { useDispatch, useSelector } from 'react-redux'
import {
  showNotificationMessage,
  updateMemberDetails,
  updateNomineeDetails,
  updateProposerDetails,
  updateUserDetails,
} from 'src/actions'
import { AGE_COMPONENT_TYPES } from 'src/utils/constants/BuyPolicy'
import { addScroll, isObjectEmpty, removeScroll } from 'src/utils/commonMethods'
import QuoteConformation from 'src/components/BuyPolicy/insuranceScreens/health/QuoteConformation'
import Modal from '@mui/material/Modal'
import IconButton from '@mui/material/IconButton'
import { Clear } from '@mui/icons-material'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { FORM_ERRORS } from 'src/utils/constants/Health'

const AgeDetailsForm = ({ gender, onEdit, editForm = false }) => {
  const classes = useStyles()
  const { guestUserDetails, loggedInUserInfo } = useSelector((state) => {
    return {
      guestUserDetails: state?.buyPolicyReducer,
      loggedInUserInfo: state?.userInfo,
    }
  })
  // Generate an array of numbers from 1 to 100 and filter number greater than 18
  const numbers = Array.from({ length: 100 }, (_, index) => index + 1)
  const ageInYears = numbers?.filter((number) => number >= 18)

  const [userInfo, setUserInfo] = useState({
    fullName: '',
    mobileNumber: '',
    pinCode: '',
  })

  const [ageDetails, setAgeDetails] = useState({
    myAge: '',
    spouseAge: '',
    motherAge: '',
    fatherAge: '',
    motherInLawAge: '',
    fatherInLawAge: '',
    kidsAge: [
      {
        id: 1,
        gender: 'MALE',
        age: '',
      },
      {
        id: 2,
        gender: 'FEMALE',
        age: '',
      },
    ],
  })

  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [popoverComponentType, setPopoverComponentType] = useState(null)
  const [isValidDetails, setIsValidDetails] = useState(true)
  const [showUserDetailForm, setShowUserDetailForm] = useState(editForm)
  const [modalOpen, setModalOpen] = useState(false)
  const dispatch = useDispatch()
  useEffect(() => {
    if (!isObjectEmpty(loggedInUserInfo?.userInfo)) {
      setUserInfo({
        ...userInfo,
        fullName: loggedInUserInfo?.userInfo?.userData?.firstName,
        mobileNumber: loggedInUserInfo?.userInfo?.userData?.mobileNumber,
      })
    }
    if (guestUserDetails?.userDetails?.ageDetails) {
      setAgeDetails(guestUserDetails?.userDetails?.ageDetails)
    }

    if (guestUserDetails?.userDetails?.fullName) {
      setUserInfo({
        ...guestUserDetails?.userDetails,
        pinCode: guestUserDetails?.userDetails?.pincode,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (modalOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [modalOpen])

  const hasFilledParentLawsAge = (data) => {
    return (
      isValidAge(data?.motherAge) ||
      isValidAge(data?.fatherAge) ||
      isValidAge(data?.motherInLawAge) ||
      isValidAge(data?.fatherInLawAge)
    )
  }

  const validateName = (name) => {
    const nameRegex = /^[A-Za-z\s]+$/
    return nameRegex?.test(name)
  }

  const validatePhoneNumber = (phoneNumber) => {
    const phoneNumberRegex = /^\d{10}$/ // Assumes 10-digit phone numbers
    return phoneNumberRegex?.test(phoneNumber)
  }

  const validatePincode = (pincode) => {
    const pincodeRegex = /^\d{6}$/ // Assumes 6-digit pin codes
    return pincodeRegex?.test(pincode)
  }

  const dispatchData = () => {
    const { userDetails, proposerDetails, memberDetails } =
      getFormattedRequestObjects(gender, userInfo, ageDetails)
    dispatch(updateUserDetails(userDetails))
    dispatch(updateProposerDetails(proposerDetails))
    dispatch(updateMemberDetails(memberDetails))
    dispatch(
      updateNomineeDetails({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        gender: '',
        relation: '',
      })
    )
  }

  const handleNext = (modal) => {
    const isAgeDetailsFilled =
      ageDetails?.myAge ||
      ageDetails?.spouseAge ||
      hasFilledParentLawsAge(ageDetails) ||
      hasFilledKidAge(ageDetails)

    const isPersonDetailsFilled =
      userInfo?.mobileNumber && userInfo?.pinCode && userInfo?.fullName

    if (!isAgeDetailsFilled || !gender) {
      // Validations for Gender Selection
      if (!isAgeDetailsFilled && gender) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FORM_ERRORS?.AGE,
          })
        )
      } else if (isAgeDetailsFilled && !gender) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FORM_ERRORS?.GENDER,
          })
        )
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FORM_ERRORS?.AGE_GENDER,
          })
        )
      }
    } else if (isAgeDetailsFilled && !showUserDetailForm) {
      // To display user details form
      setShowUserDetailForm(true)
    } else if (isAgeDetailsFilled && showUserDetailForm) {
      // Validations for age details
      if (!isPersonDetailsFilled) {
        setIsValidDetails(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FORM_ERRORS?.MANDATORY_FIELDS,
          })
        )
      } else if (!validateName(userInfo.fullName)) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FORM_ERRORS?.NAME,
          })
        )
      } else if (!validatePhoneNumber(userInfo?.mobileNumber)) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FORM_ERRORS?.PHONE,
          })
        )
      } else if (!validatePincode(userInfo?.pinCode)) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FORM_ERRORS?.PINCODE,
          })
        )
      } else {
        // Success state where we save data to redux and redirect
        dispatchData()
        if (editForm) {
          onEdit()
        } else {
          setModalOpen(modal)
        }
      }
    }
  }

  const handleUserDetailsChange = (event) => {
    setUserInfo({
      ...userInfo,
      [event?.target?.name]: event?.target?.value,
    })
  }

  const handleAgeChange = (event) => {
    setAgeDetails({
      ...ageDetails,
      [event?.target?.name]: Number(event?.target?.value),
    })
    closePopover()
  }

  const handleClear = (key) => {
    setAgeDetails({
      ...ageDetails,
      [key]: '',
    })
  }
  const handleKidsAgeChange = (data) => {
    setAgeDetails({
      ...ageDetails,
      kidsAge: data,
    })
  }

  const handleParentsAgeChange = (data) => {
    setAgeDetails({
      ...ageDetails,
      ...data,
    })
  }

  const openPopover = (event, type) => {
    setPopoverAnchor(event?.currentTarget)
    setIsPopoverOpen(true)
    setPopoverComponentType(type)
    removeScroll()
  }

  const closePopover = () => {
    setIsPopoverOpen(false)
    setPopoverAnchor(null)
    setPopoverComponentType(null)
    addScroll()
  }

  const getTotalNumberOfKids = () => {
    const kidsArray = ageDetails?.kidsAge
    const filteredKidsArray = kidsArray?.filter((kidDetails) =>
      isValidAge(kidDetails?.age)
    )
    return filteredKidsArray?.length
  }

  const getTotalNumberOfParents = () => {
    let count = 0
    if (isValidAge(ageDetails?.motherAge)) {
      count++
    }

    if (isValidAge(ageDetails?.fatherAge)) {
      count++
    }

    if (isValidAge(ageDetails?.motherInLawAge)) {
      count++
    }

    if (isValidAge(ageDetails?.fatherInLawAge)) {
      count++
    }

    return count
  }
  const getPopoverComponent = () => {
    switch (popoverComponentType) {
      case AGE_COMPONENT_TYPES?.me:
        return (
          <>
            <div className={classes.ageSelectContainer}>
              <span className={classes.ageSelectHeading}>
                Please select your age
              </span>
              <Select
                id={'myAge'}
                name={'myAge'}
                value={ageDetails?.myAge}
                placeholder={'Select'}
                onChange={handleAgeChange}
                className={`form-input ${
                  !isValidDetails && !ageDetails?.myAge
                    ? 'form-input-required'
                    : null
                } ${classes.ageInput}`}
                displayEmpty
                sx={{
                  '&  .MuiInputBase-root': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '&  .MuiSelect-select': {
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: ageDetails?.myAge ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='myAgeClear'
                    sx={{ display: ageDetails?.myAge ? '' : 'none' }}
                    className={'clear-button'}
                    onClick={() => handleClear('myAge')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>Select</MenuItem>
                {ageInYears?.map((number) => (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </>
        )
      case AGE_COMPONENT_TYPES?.spouse:
        return (
          <>
            <div className={classes.ageSelectContainer}>
              <span className={classes.ageSelectHeading}>
                Please select your age
              </span>
              <Select
                id={'spouseAge'}
                name={'spouseAge'}
                placeholder={'Select'}
                value={ageDetails?.spouseAge}
                onChange={handleAgeChange}
                className={`form-input ${classes.ageInput}`}
                displayEmpty
                sx={{
                  '&  .MuiInputBase-root': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '&  .MuiSelect-select': {
                    minHeight: 'unset',
                    width: '100px',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: ageDetails?.spouseAge ? 'none' : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='spouseAgeClear'
                    sx={{ display: ageDetails?.spouseAge ? '' : 'none' }}
                    className={'clear-button'}
                    onClick={() => handleClear('spouseAge')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>Select</MenuItem>
                {ageInYears?.map((number) => (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </>
        )
      case AGE_COMPONENT_TYPES?.kids:
        return (
          <KidsAgeForm
            id='kidsAgeForm'
            kidsDetails={ageDetails?.kidsAge}
            handleKidsAgeChange={handleKidsAgeChange}
            parentsMinAge={getParentsMinAge(ageDetails)}
          />
        )

      case AGE_COMPONENT_TYPES?.parentAndInLaws:
        return (
          <ParentsAndInLawsAgeForm
            id='parentsAndInLawsAgeForm'
            ageDetails={ageDetails}
            onParentsAgeChange={handleParentsAgeChange}
            minAge={getParentsMinAge(ageDetails) + 18}
          />
        )
      default:
        return
    }
  }

  return (
    <>
      {modalOpen ? (
        <Modal id='modal' open={modalOpen} onClose={() => handleNext(false)}>
          <div className={`${classes.modalRoot} modal-container`}>
            <QuoteConformation />
          </div>
        </Modal>
      ) : null}
      <div className={classes.mainContainer}>
        <Popover
          id={'popover'}
          open={isPopoverOpen}
          anchorEl={popoverAnchor}
          onClose={closePopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {getPopoverComponent()}
        </Popover>
        <span className={classes.heading}>
          Select your loved ones (Whom do you want to insure?)
        </span>
        <div className={classes.memberSelectorContainer}>
          <div
            className={`${classes.memberAgeSelector} ${
              ageDetails.myAge ? classes.memberSelected : ''
            }`}
            id='meAgeSelector'
            onClick={(event) => openPopover(event, AGE_COMPONENT_TYPES?.me)}
          >
            Me&nbsp;{ageDetails?.myAge ? `(${ageDetails?.myAge} Y)` : ''}
          </div>
          <div
            className={`${classes.memberAgeSelector} ${
              ageDetails?.spouseAge ? classes.memberSelected : ''
            }`}
            id='spouseAgeSelector'
            onClick={(event) => openPopover(event, AGE_COMPONENT_TYPES?.spouse)}
          >
            Spouse&nbsp;
            {ageDetails?.spouseAge ? `(${ageDetails?.spouseAge} Y)` : ''}
          </div>
          <Badge badgeContent={getTotalNumberOfKids()} color={'primary'}>
            <div
              className={`${classes.memberAgeSelector} ${
                hasFilledKidAge(ageDetails) ? classes.memberSelected : ''
              }`}
              id='kidsAgeSelector'
              onClick={(event) => openPopover(event, AGE_COMPONENT_TYPES?.kids)}
            >
              Kids
            </div>
          </Badge>

          <Badge badgeContent={getTotalNumberOfParents()} color={'primary'}>
            <div
              className={`${classes.memberAgeSelector} ${
                hasFilledParentLawsAge(ageDetails) ? classes.memberSelected : ''
              }`}
              id='parentsAgeSelector'
              onClick={(event) =>
                openPopover(event, AGE_COMPONENT_TYPES?.parentAndInLaws)
              }
            >
              Parents/In-laws
            </div>
          </Badge>
        </div>

        {showUserDetailForm ? (
          <div className={classes.memberDetailsFormContainer}>
            {/* form for capturing data*/}
            <div className={classes.formInputContainer}>
              <input
                id={'fullName'}
                name={'fullName'}
                className={`form-input ${
                  !isValidDetails && !userInfo?.fullName
                    ? 'form-input-required'
                    : null
                }`}
                value={userInfo?.fullName ?? ''}
                onChange={handleUserDetailsChange}
                placeholder={'Full Name'}
              />
              <input
                id={'mobileNumber'}
                name={'mobileNumber'}
                className={`form-input ${
                  !isValidDetails && !userInfo?.mobileNumber
                    ? 'form-input-required'
                    : null
                }`}
                value={userInfo.mobileNumber ?? ''}
                onChange={(event) => {
                  event.target.value = Math.max(
                    0,
                    parseInt(event?.target?.value)
                  )
                    ?.toString()
                    ?.slice(0, 10)
                  handleUserDetailsChange(event)
                }}
                placeholder={'Mobile No'}
                type='number'
              />
            </div>
            <div className={classes.formInputContainer}>
              <input
                id={'pinCode'}
                name={'pinCode'}
                className={`form-input ${
                  !isValidDetails && !userInfo?.mobileNumber
                    ? 'form-input-required'
                    : null
                }`}
                value={userInfo?.pinCode ?? ''}
                onChange={(event) => {
                  event.target.value = Math.max(
                    0,
                    parseInt(event?.target?.value)
                  )
                    ?.toString()
                    ?.slice(0, 6)
                  handleUserDetailsChange(event)
                }}
                placeholder={'Enter Pincode'}
                type='number'
              />
            </div>
          </div>
        ) : null}
        <div className={classes.actionsContainer}>
          <Button
            id='saveButton'
            variant={'contained'}
            className={classes.nextButton}
            onClick={() => handleNext(true)}
          >
            {editForm ? 'Save' : 'Next'}
          </Button>
        </div>
      </div>
    </>
  )
}

export default AgeDetailsForm

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',
    gap: '40px',
  },
  heading: {
    fontSize: '17px',
    marginBottom: '15px',
  },
  memberSelectorContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
    marginTop: '-40px',
  },
  memberAgeSelector: {
    height: '35px',
    width: '94px',
    background: COLORS.WHITE,
    boxShadow: '0px 3px 8px 0px #00000026',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    fontSize: '12px',
    cursor: 'pointer',
    border: '1px solid #ffffff',
    '&:hover': {
      border: '1px solid #4dc3e3',
    },
  },
  memberDetailsFormContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginTop: '20px',
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nextButton: {
    background: 'linear-gradient(226.67deg, #73CFEE 34.4%, #5DB2C9 123.77%)',
    color: '#FFFFFF !important',
    width: '117px',
    height: '37px',
    boxShadow: 'none !important',
    borderRadius: '5px !important',
    textTransform: 'capitalize !important',
    fontWeight: 'bold !important',
  },
  formInputContainer: {
    display: 'flex',
    gap: '10px',
    width: '100%',
  },
  pinCodeInput: {
    border: '0',
    width: '100%',
    fontStyle: 'italic',
  },
  pinCodeSearchImage: {
    padding: '5px',
  },
  ageSelectContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  ageSelectHeading: {
    fontSize: '11px',
    marginBottom: '5px',
  },
  badge: {
    background: '#4DC3E3',
  },
  memberSelected: {
    border: '1px solid #4dc3e3 !important',
  },
  modalRoot: {
    maxWidth: '600px',
    maxHeight: '90%',
    width: '100%',
  },
  ageInput: {
    width: '140px !important',
    height: '30px',
  },
})
